export enum SearchParamEnum {
  Page = 'page',
}
